<template>
  <setting-layout
    header-title="历史记录"
    footer-text="返回"
    @footer-click="goBack"
  >
    <el-table
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        prop="importedAt"
        label="导入时间"
      >
        <template #default="{ row }">
          {{ dateFormat(row.importedAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="licenseId"
        label="licenseId"
      ></el-table-column>
      <el-table-column
        prop="tokenCount"
        label="增加额度 (个)"
      ></el-table-column>
      <el-table-column
        prop="createdBy"
        label="操作人员"
      >
        <template #default="{ row }">
          {{ row.createdBy || '--' }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </setting-layout>
</template>

<script>
import SettingLayout from '@/components/setting-layout.vue';
import { getLicenseList } from '@/api/base';
import { dateLocaleFormat } from '@/lib/date-format';

export default {
  name: 'TokenHistory',
  components: {
    SettingLayout,
  },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0, // Replace with actual total count from API
    };
  },
  methods: {
    dateFormat(date) {
      return dateLocaleFormat(date);
    },
    goBack() {
      // Implement navigation logic, e.g., this.$router.go(-1);
      this.$router.go(-1);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      // Fetch data for new page size
      this.getLicenseList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // Fetch data for new page
      this.getLicenseList();
    },
    getLicenseList() {
      // Assuming the API requires pagination parameters
      const params = {
        page: this.currentPage,
        size: this.pageSize,
      };
      getLicenseList(params)
        .then((res) => {
          // Assuming the response structure is { data: { records: [], total: 0 } }
          // or similar, adjust based on your actual API response
          if (res.data) {
            this.tableData = res.data; // Or res.data.records or whatever the array is called
            this.total = res.total; // Or res.data.totalRecords etc.
          } else {
            // Fallback if response structure is just the array
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch((error) => {
          console.error('Error fetching license list:', error);
          // Optionally, show an error message to the user
          this.tableData = []; // Clear table on error
          this.total = 0;
        });
    },
  },
  mounted() {
    this.getLicenseList();
  },
};
</script>

<style scoped>
/* Add any specific styles for this component here */
.el-pagination {
  text-align: right;
  margin-top: 20px;
}
</style>
